var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.actorMap[_vm.actor.actor])?_c(_vm.actorMap[_vm.actor.actor],{tag:"component",attrs:{"actor":_vm.actor}}):_c('pre',[_vm._v(_vm._s(_vm.actor))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }